module.exports = __webpack_public_path__ + "img/NDZ_Battery.c40a8889.png";